// The tile inventory rules version 1 plays with, frozen: copied from @words-happen/game-config when the version was
// released, so a later change to the inventory can't change what an old game's tiles score or how its bag is made.

/** A face in the inventory: its characters, its points and the weighted corpus frequency that apportions the bag. */
export type InventoryTile = readonly [face: string, points: number, frequency: number];

/** Every face a bag may hold, single letters first, then clusters: the order a bag is built in. */
export const TILE_INVENTORY: readonly InventoryTile[] = [
  ['E', 1, 548563],
  ['S', 1, 429255],
  ['I', 1, 419173],
  ['A', 2, 351763],
  ['R', 2, 339379],
  ['N', 2, 330321],
  ['T', 2, 322111],
  ['O', 2, 289071],
  ['L', 2, 245531],
  ['C', 3, 190572],
  ['D', 3, 182359],
  ['U', 3, 155842],
  ['G', 3, 146598],
  ['P', 3, 136863],
  ['M', 3, 127583],
  ['H', 3, 105960],
  ['B', 4, 88634],
  ['Y', 4, 71555],
  ['F', 4, 64571],
  ['V', 5, 47767],
  ['K', 5, 42868],
  ['W', 5, 40795],
  ['Z', 6, 19198],
  ['X', 6, 12886],
  ['Q', 7, 8812],
  ['J', 7, 8508],
  ['IN', 1, 113455],
  ['ES', 1, 100162],
  ['ER', 1, 95796],
  ['NG', 2, 71473],
  ['TI', 2, 70252],
  ['ED', 2, 67272],
  ['ING', 2, 64066],
  ['TE', 2, 63903],
  ['RE', 2, 62514],
  ['AT', 2, 60635],
  ['ON', 3, 58281],
  ['ST', 3, 55326],
  ['EN', 3, 50658],
  ['IS', 3, 47812],
  ['LE', 3, 46961],
  ['RI', 3, 45408],
  ['LI', 3, 45164],
  ['RA', 3, 44467],
  ['AL', 3, 43583],
  ['AN', 3, 43319],
  ['AR', 3, 40799],
  ['NT', 4, 39248],
  ['OR', 4, 37672],
  ['SE', 4, 36164],
  ['DE', 4, 35512],
  ['NE', 4, 35280],
  ['CO', 4, 33502],
  ['RO', 4, 31181],
  ['IC', 4, 30973],
  ['ION', 5, 24654],
  ['ATI', 5, 23143],
  ['ERS', 5, 21359],
  ['TIO', 5, 20563],
  ['TER', 5, 19237],
  ['ATE', 5, 18966],
  ['ENT', 5, 17301],
  ['ESS', 6, 16305],
  ['IES', 6, 15799],
  ['TIN', 6, 15383],
  ['EST', 6, 15185],
  ['NES', 6, 12915],
  ['ONS', 6, 12704],
  ['TED', 6, 12619],
  ['IST', 6, 11283],
  ['CON', 7, 11018],
  ['RES', 7, 10777],
  ['LIN', 7, 10709],
  ['ALI', 7, 10464],
  ['ISE', 7, 9728],
  ['ALL', 7, 9664],
  ['INE', 7, 9628],
  ['VER', 7, 9432],
  ['SES', 7, 9410],
  ['RAT', 7, 9178],
  ['PER', 7, 9155],
  ['RIN', 7, 9104],
];

/** What a blank scores, whatever its length and whatever it is played as. */
export const BLANK_TILE_POINTS = 1;
